var _desc, _defs, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _path15, _polyline6, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "281px",
    height: "146px",
    viewBox: "0 0 281 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,70.5 L280.5,70.5",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 279,
    height: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    width: 4,
    height: 4,
    x: 137,
    y: 66,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-4"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-4",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-1",
    transform: "translate(-580.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-2",
    transform: "translate(580.000000, 358.000000)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Line",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,33.5 C44,27.7010101 39.2989899,23 33.5,23 C27.7010101,23 23,27.7010101 23,33.5",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84,57.5 C84,51.7010101 79.2989899,47 73.5,47 C67.7010101,47 63,51.7010101 63,57.5",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124,33.5 C124,27.7010101 119.29899,23 113.5,23 C107.70101,23 103,27.7010101 103,33.5",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64,80 C64,74.4771525 59.2989899,70 53.5,70 C47.7010101,70 43,74.4771525 43,80",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(53.500000, 80.000000) scale(1, -1) translate(-53.500000, -80.000000) "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22,72 C22,66.4771525 17.2989899,62 11.5,62 C5.70101013,62 1,66.4771525 1,72",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(11.500000, 72.000000) scale(1, -1) translate(-11.500000, -72.000000) "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140,122 C140,116.477153 137.29899,112 131.5,112 C125.70101,112 123,116.477153 123,122",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(131.500000, 117.000000) scale(1, -1) translate(-131.500000, -117.000000) "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104,106 C104,100.477153 99.2989899,96 93.5,96 C87.7010101,96 83,100.477153 83,106",
    id: "Shape",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(93.500000, 101.000000) scale(1, -1) translate(-93.500000, -101.000000) "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5,33.5 L43.5,79.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5,57.5 L63.5,79.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,57.5 L83.5,95.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5,33.5 L103.5,95.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5,33.5 L123.5,111.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,33.5 L22.5,71.5",
    id: "Line-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5,2 L140.5,145",
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "url(#pattern-3)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    points: "141 70 157 70 157 117 177 117 177 70.25 197 70.25 197 117.5 217 117.5 217 70 237 70 237 117 257 117 257 70.25 280.5 70.25 280.5 143.5 141.5 143.5"
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "141 24.5 157.5 24.5 157.5 118"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(167.250000, 70.750000) scale(1, -1) translate(-167.250000, -70.750000) ",
    points: "157 24 177.5 24 177.5 117.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "177 24.5 197.5 24.5 197.5 118"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(207.250000, 70.750000) scale(1, -1) translate(-207.250000, -70.750000) ",
    points: "197 24 217.5 24 217.5 117.5"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "217 24.5 237.5 24.5 237.5 118"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257,24.5 L280.5,24.5",
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(247.250000, 70.750000) scale(1, -1) translate(-247.250000, -70.750000) ",
    points: "237 24 257.5 24 257.5 117.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,145.5 L280.5,145.5 L280.5,0.5 L0.5,0.5 L0.5,145.5 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration2);
export default __webpack_public_path__ + "static/media/illustration-2.5803c3ab90b98ab11e29c5b0b90cf75c.svg";
export { ForwardRef as ReactComponent };